import { DemoWorld } from './DemoWorld';
import type { WorldView } from '../types';

/** A local practice track. Deliberately exposes no wallet, trade, claim or NFT actions. */
export class PracticeWorld {
  private world: DemoWorld;
  constructor(seed = 20261015) {
    this.world = new DemoWorld({ seed, autoplay: false, crowd: false, windowSeconds: 1 });
    // Start at the playable track, without waiting through simulated funding/randomness.
    for (let i = 0; i < 30 && this.world.getView().phase !== 'running'; i++) this.world.advanceMs(1000);
  }
  getView() { return this.world.getView(); }
  advance(ms: number) {
    if (this.getView().phase === 'running') this.world.advanceMs(ms);
  }
  steer(direction: -1 | 0 | 1) { this.world.steerPractice(direction); }
}

/** Unknown/stale chain state never masquerades as a verified break between races. */
export function betweenRaces(view: WorldView): boolean {
  return view.mode !== 'demo' && view.freshness.api === 'ok' && !view.freshness.stale &&
    ['warm-up', 'finished', 'replay'].includes(view.phase);
}
